module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-5.81485492.jpg";